module.exports = __webpack_public_path__ + "static/media/back.ef341bac.jpeg";